class SFLoginCtrl {
  constructor(AuthService, FEService, $state, $window, FlashService, $scope, firebase) {
    'ngInject';
    this.firebase = firebase;
    this.AuthService = AuthService;
    this.FEService = FEService;
    this.$state = $state;
    this.$window = $window;
    this.FlashService = FlashService;
    this.userMessages = [];
    this.authData = {
      "provider": "Salesforce"
    };
    this.loadNote = "Logging In...";
    const stopWatch = $scope.$watch("$ctrl.options", (newVal, oldVal) => {
      if (newVal && newVal["realm"]) {
        this.authData["realm"] = newVal["realm"];
        stopWatch();
      }
    });
  }
  
  lower(){
    if (this.authData.realm) {
      this.authData.realm = this.authData.realm.toLowerCase();
    }
  }
  
  changeProvider() {
    this.$state.go('login', { provider: '?' }, { reload: true });
  }

  async login(authData){
    this.userMessages = [];
    this.loading = true;
    try {
      const success = await this.AuthService.login(authData);
      this.FlashService.success("Thanks for Logging In.");
      if (this.options && this.options.successState ){
        this.$state.go(this.options.successState, this.options.successStateParams);
      }
      if (this.options && this.options.onSuccess ){
        this.options.onSuccess(success);
      }
    } catch (error){
      this.FlashService.error(error.message);
      this.userMessages.push({"class":"alert-danger", "message": error.message});
      if ( (this.options || {}).onFailure ){
        this.options.onFailure(error);
      }
    }
    this.loading = false;
  }
}

export default {
  bindings: {
    options: "<"
  },
  templateUrl: "providers/salesforce/sf-login/sf-login.component.html",
  controller: SFLoginCtrl
};
